import React, { useEffect, useState } from 'react'

import * as S from './TextTab.style'
import TextForm from '../TextForm'
import { TrainingStatus, getTrainingStatusFromSources } from '../../../../settings/constants/trainingStatus'
import {
  deleteKnowledgeSources,
  getKnowledgeSources,
  trainKnowledgeSources,
  updateTextKnowledgeSources,
  SourceTypeMap
} from 'tabs/nlp/api/websiteKnowledgeBase'
import { alertSuccess, alertError } from 'api'
import SourcesTable from '../SourcesTable'
import Select from 'react-select'
import { customStyles } from '../SettingsTab/SettingsTab.style'
import LoaderScreen from 'uiKit/loaders/loaderScreen'
import LoaderOverlay from 'uiKit/loaders/loaderOverlay'

export const onTrainSuccessAlertMessage =
  'Training has successfully started. Once training is completed, we will send you an email notification'

export const TextTab = ({ activeBot, sourceId }) => {
  const [sources, setSources] = useState([])
  const [trainingStatus, setTrainingStatus] = useState(TrainingStatus.PENDING)
  const [level, setLevel] = useState('GENERIC_DOC')
  const [loading, setLoading] = useState(true)
  const [isAdding, setIsAdding] = useState(false)

  useEffect(() => {
    fetchKnowledgeSources()
  }, [])

  const fetchKnowledgeSources = async (): Promise<void> => {
    getKnowledgeSources(activeBot.id, 'TEXT')
      .then(res => {
        const sourcesList = res?.sources || []
        setSources(sourcesList)
        setTrainingStatus(getTrainingStatusFromSources(sourcesList))
      })
      .finally(() => setLoading(false))
  }

  const handleAdd = async (text: string, title: string): Promise<void> => {
    const body = { text, title, type: SourceTypeMap.TEXT, hierarchyLevel: level }

    setIsAdding(true)
    try {
      await updateTextKnowledgeSources(activeBot.id, body, false)
      alertSuccess('Text is added successfully')
      await fetchKnowledgeSources()
    } finally {
      setIsAdding(false)
    }
  }

  const handleDelete = source => {
    const source_id = source._id
    return deleteKnowledgeSources(activeBot.id, source_id)
      .then(() => {
        alertSuccess('Text is deleted successfully')
        return fetchKnowledgeSources()
      })
  }

  const handleTrain = () => {
    const body = sources.filter(x => ['NOT_TRAINED', 'FAILED'].includes(x.status)).map(x => x._id)
    trainKnowledgeSources(activeBot.id, body)
      .then(() => {
        setTrainingStatus(TrainingStatus.PENDING)
        alertSuccess(onTrainSuccessAlertMessage)
      })
      .catch(error => alertError(error?.message || 'Something went wrong'))
  }

  const options = [
    { value: 'FAQS_FLOWS', label: 'FAQs/flows' },
    { value: 'COMPANY_DOC', label: 'Careco docs' },
    { value: 'GENERIC_DOC', label: 'Generic' },
  ]

  const defaultOption = { value: 'GENERIC_DOC', label: 'Generic' }

  const handleChange = (selectedOption) => {
    setLevel(selectedOption.value)
  }

  if (loading) {
    return <LoaderScreen />
  }

  return (
    <S.TextTab>
      <S.SelectionDiv>
        <S.SubHeader>Knowledge Type</S.SubHeader>
        <Select
          styles={customStyles}
          options={options}
          onChange={handleChange}
          defaultValue={defaultOption}
        />
      </S.SelectionDiv>
      <TextForm onClick={handleAdd} trainingStatus={trainingStatus} />
      <SourcesTable
        sources={sources}
        setSources={setSources}
        onDelete={handleDelete}
        onTrain={handleTrain}
        trainingStatus={trainingStatus}
        sourceId={sourceId}
        fetchKnowledgeSources={fetchKnowledgeSources}
      />
      {isAdding && <LoaderOverlay />}
    </S.TextTab>
  )
}
